<template>
    <div class="product-list-short">
        <template v-if="loading">
            <Loading>
                <template v-slot:title>
                    Loading your data…
                </template>
            </Loading>
        </template>
        <template v-else>
            <div class="product-list-short__item" v-for="product in products">
                <div class="product-list-short__item-inside">

                    <div class="product-list-short__item-visual" v-if="product.icon" v-html="`<i data-icon='&#x${product.icon};'></i>`"></div>
                    <div class="product-list-short__item-visual" v-else-if="product.image">
                        <img :src="product.image.src" :alt="product.image.alt" :width="product.image.width" :height="product.image.height" :title="product.image.title">
                    </div>

                    <div class="product-list-short__item-content">
                        <h2 class="product-list-short__item-name">{{ product.name }}</h2>

                        <div class="product-list-short__item-price product-price product-price--lg">
                            <div class="product-price__value">{{ product.price }}</div>
                            <div class="product-price__text">(VAT incl.)</div>
                        </div>
                    </div>

                    <div class="product-list-short__item-buttons">
                        <div class="buttons-group-sm buttons-group--no-wrap">
                            <button class="btn btn-secondary btn-one-icon rounded-circle" :content="product.teaser" v-tippy="{ placement : $mq === 'xs' ? 'bottom'  : 'left-start' }" v-if="product.teaser">
                                <i class="icon icon-info"></i>
                            </button>

                            <button class="btn btn-primary btn-one-icon rounded-circle" :content="product.inCart ? 'Remove from Cart' : 'Add to Cart'" v-tippy="{ placement : 'top' }" @click="product.inCart ? onProductRemove(product) : onProductAdd(product)" :disabled="loadingProductId">
                                <i class="icon" :class="loadingProductId === product.id  ? 'spinner-border spinner-border-sm' : product.inCart ? 'icon-x': 'icon-shopping-bag'"></i>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
    import Loading from "../_components/Loading";
    import CartObserver from '../_helpers/cart-observer';
    import { handleAjaxError } from '../_helpers/error-handler';
    import {trackAddToCart, trackRemoveFromCart, trackViewItem} from '../_helpers/analytics';

    export default {
        name: 'ServiceList',
        components: { Loading },
        data() {
            return {
                loading: true,
                loadingProductId: null,
                products: [],
            };
        },
        methods: {
            onProductAdd(product) {
                this.loadingProductId = product.id;
                this.$http.post(this.$config.addProductUrl, { product: product.id, quantity: 1 }).then(() => {
                    this.products.find(v => v.id === product.id).inCart = true;

                    CartObserver.update(this);
                    CartObserver.showCart();

                    trackAddToCart({
                        id: product.id,
                        name: product.name,
                        price: product.priceRaw,
                        type: product.type,
                        quantity: 1,
                    });
                }).catch(handleAjaxError).finally(() => {
                    this.loadingProductId = null;
                });
            },
            onProductRemove(product) {
                this.loadingProductId = product.id;
                this.$http.post(this.$config.removeProductUrl, { product: product.id, quantity: 0 }).then(() => {
                    this.products.find(v => v.id === product.id).inCart = false;

                    CartObserver.update(this);
                    CartObserver.showCart();

                    trackRemoveFromCart({
                        id: product.id,
                        name: product.name,
                        price: product.priceRaw,
                        type: product.type,
                    });
                }).catch(handleAjaxError).finally(() => {
                    this.loadingProductId = null;
                });
            },
        },
        mounted() {
            this.$http.get(this.$config.getCartUrl).then(response => {
                this.products = this.$config.products.map(product => ({...product, inCart: response.data.items.some(item => item.id === product.id) }));

                CartObserver.update(this, response.data);
                CartObserver.subscribe((data, initiator) => {
                    if (initiator !== this) {
                        this.products.forEach(product => product.inCart = data.items.some(item => item.id === product.id));
                    }
                });
            }).catch(handleAjaxError).finally(() => {
                this.loading = false;
            });

            this.$config.products.forEach(product => {
                trackViewItem({
                    id: product.id,
                    name: product.name,
                    price: product.priceRaw,
                    type: product.type,
                });
            });
        },
    }
</script>
